import Stack from '@/components/Custom/ModalStack';

export default function PrivateTeamJoinLayoutRoute() {
  return <Stack />;
}
